import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-benemeriti',
  templateUrl: './benemeriti.component.html',
  styleUrls: ['./benemeriti.component.css']
})
export class BenemeritiComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
